import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import Select from '../../../../common/Select';

const StyledEventsItemContainer = styled.div`
  border: 1px solid #999999;
  width: calc(100% - 20px);
  padding: 10px;
  margin: 10px;

  .full-width-container {
    width: 100%;
  }

  .row-flex {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .select-container {
    display: flex;
    align-items: center;
  }

  .unique-char {
    font-weight: bold;
    margin-right: 10px;
  }

  .button-container {
    display: flex;
    align-items: center;
  }
`;

const StyledSelect = styled(Select)`
  width: 250px;
  font-weight: bold;
  outline: ${({ isValid }) => (isValid ? '' : 'solid red 1px')};
`;

// изъятие isVisible, чтобы не пробрасывалось в DOM элемент
// и не кидало warning в консоль
const StyledButton = styled(({ isVisible, ...props }) => <Button {...props} />)`
  border: none;
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
`;

const EventsItem = (props) => {
  const {
    eventId,
    uniqueChar,
    event,
    events,
    multipleEvents,
    onRemove,
    onChangeEvent,
    visible,
    showNotValidFields,
    children,
    getEventMetainf,
  } = props;

  const [isValid, setValid] = useState(true);

  useEffect(() => {
    if (showNotValidFields) {
      setValid(!!event);
    }
  }, [event, showNotValidFields]);

  return (
    <StyledEventsItemContainer className="custom-events-item" key={eventId}>
      <div className="full-width-container">
        <div className="row-flex">
          <div className="select-container">
            <div className="unique-char">{uniqueChar}.</div>
            <StyledSelect
              className="ant-select-border-bottom"
              isValid={isValid}
              value={event || undefined}
              values={[...events].sort((a, b) => a.localeCompare(b))}
              allowClear={false}
              onChange={(e) => {
                onChangeEvent(e, getEventMetainf(e));
              }}
              placeholder="Select an event"
            />
          </div>
          <div className="button-container">
            <StyledButton icon={<CloseOutlined />} isVisible={multipleEvents} onClick={onRemove} />
          </div>
        </div>
        {visible && children}
      </div>
    </StyledEventsItemContainer>
  );
};

export default EventsItem;
